
   <template>
  <b-sidebar
    id="sidebar-add-new-agency"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add agency</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <b-form class="p-2" @submit.prevent>
        <!-- name -->
        <b-form-group label="VAT N°" label-for="v-vat">
          <b-form-input id="v-vat" placeholder="VAT N°" v-model="client.vat" />
        </b-form-group>

        <!-- Prénom -->
        <b-form-group label="Port of registry	" label-for="v-Port">
          <b-form-input
            id="v-port"
            placeholder="Port"
            v-model="client.port"
          />
        </b-form-group>

        <!-- email -->
        <b-form-group label="Social reason" label-for="v-social">
          <b-form-input
            id="v-social"
            placeholder="Social reason"
            v-model="client.socialReason"
          />
        </b-form-group>

        <!-- Prix ht -->
        <b-form-group label="Email" label-for="v-Email">
          <b-form-input
            id="v-Email"
            placeholder="Email"
            v-model="client.email"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="addClient(), hide"
          >
            Add
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Close
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import axios from "axios";

import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ToastificationContent,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  setup() {
    const client = ref({
      vat: "",
      port: "",
      socialReason: "",
      email:"",
    });

    return {
      client,
    };
  },
  methods: {
    addClient() {
      this.client.createdBy= JSON.parse(localStorage.getItem("userData"))._id,
      axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/customers",
          this.client
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Client bien ajouté",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$emit("update-client", this.client);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erreur lors de l'ajout du client",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
